import { DispositionJobResponse, DispositionJobResponseItem } from '@/types/service-response'

export class DispositionJob {
  public constructor (
    readonly id: number | undefined,
    readonly number: number,
    readonly address: string,
    readonly created: string,
    readonly createdBy: string,
    readonly status: number,
    readonly personalDispositionJobDetailId: number
  ) {}

  static createFromResponse (responseData: DispositionJobResponse): Array<DispositionJob> {
    let result: Array<DispositionJob> = []
    if (responseData) {
      result = responseData.map((item: DispositionJobResponseItem ) => {
        return new DispositionJob(
          item.ID,
          item.ID,
          item.GenAdresse,
          item.ErstelltAm,
          item.VollerName,
          item.Status,
          item.PersonalDispoJobsID
        )
      })
    }
    return result
  }
}